export const SelfAssessmentPageData = {
  topbarTitleText: 'Self Assessment',
  newAssessmentBtnText: 'New Assessment',
  createAssessmentModal: {
    title: 'Select Your Self Assessment Type!',
    selectMenuOne: {
      label: 'Attachment ',
      subTitle: 'Create a new Attachment style Assessment'
    },
    selectMenuTwo: {
      label: 'Percentage ',
      subTitle: 'Create a new Percentage style Assessment'
    }
  },
  cardSection: {
    cardOneTitle: 'Completed Assessments',
    cardTwoTitle: 'Most used',
    cardThreeTitle: 'Common Time'
  },
  horizontalCardSection: {
    title: 'Manage Assessments',
    viewBtnText: 'View All',
    noDataText: 'No data available',
    actionDropdownItems: {
      ItemOne: 'Edit',
      ItemTwo: 'View',
      ItemThree: 'Delete'
    },
    usedByString: {
      textBeforeUserCount: 'Used',
      textAfterUserCount: 'times'
    },
    cardActionButtonOne: 'Attachment',
    cardActionButtonTwo: 'Percentage'
  },
  assessmentCardSection: {
    cardOne: {
      title: 'Top 5 Assessments',
      notFound: 'Assessment not found'
    },
    cardTwo: {
      title: 'Completed Assessments',
      resultLabelOne: 'Complete',
      resultLabelTwo: 'Incomplete'
    },
    cardThree: {
      title: 'Common Time',
      resultAlternativeOne: 'Morning',
      resultAlternativeTwo: 'Afternoon'
    },
    cardFour: {
      title: 'Average Scores',
      resultAlternativeOne: 'Morning',
      resultAlternativeTwo: 'Afternoon'
    }
  },
  bottomCardSection: {
    cardOne: {
      title: 'Percentage of incomplete Assessments'
    },
    cardTwo: {
      title: 'Drop-off point',
      optionLabelOne: 'Intro',
      optionLabelTwo: 'About',
      optionLabelThree: 'Questions'
    },
    cardThree: {
      title: 'Weekly Usage',
      supportText: 'users',
      optionLabelTwo: 'About',
      optionLabelThree: 'Questions'
    }
  }
};

export const ViewAllAssessmentPageData = {
  topbarTitleText: 'All Assessments',
  searchPlaceholder: 'Search Assessments',
  actionBtnTextAsPerAssessmentType: {
    defaultBtnText: 'Filter',
    typeZeroBtnText: 'Draft',
    typeOneBtnText: 'Inactive',
    typeTwoBtnText: 'Active',
    typeThreeBtnText: 'Send for Approval',
    typeFourBtnText: 'Rejected',
    typeFiveBtnText: 'Deleted',
    typeSixBtnText: 'Published'
  },
  allAssessmentHeadingText: 'All Assessments',
  emptyDataText: 'No Assessment available',
  templateCards: {
    actionDropdownItems: {
      ItemOne: 'Edit',
      ItemTwo: 'View',
      ItemThree: 'Delete'
    },
    usedByString: {
      textBeforeUserCount: 'Used',
      textAfterUserCount: 'times'
    },
    cardActionButtonOne: 'Attachment',
    cardActionButtonTwo: 'Percentage'
  }
};

export const CreateSelfAssessmentPageData = {
  topbarTitleText: 'Self Assessment',
  actionBtnText: {
    editBtnText: 'Edit',
    previewBtnText: 'Preview',
    viewBtnText: 'View',
    resultBtnText: 'Result',
    shareBtnText: 'Share'
  },
  formFields: {
    formEntryOne: {
      label: 'Assessment Title',
      placeholder: 'Enter title: e.g Social Anxiety Assessment'
    },
    formEntryTwo: {
      label: 'Assessment Description',
      placeholder: 'Thank you for taking time to answer this Assessment.'
    },
    formEntryThree: {
      label: 'About Assessment',
      placeholder: 'Enter some copy covering what this assessment is about:'
    },
    formEntryFour: {
      label: 'Who is this for?',
      placeholder: 'Enter some details of who may take this assessment:'
    },
    formEntryFive: {
      label: 'Is it accurate ?',
      placeholder: 'Enter some copy covering the accuracy of this assessment:'
    },
    resultMessages: {
      resultMessageOne: {
        label: 'Result Message for 0-25%',
        placeholder: 'Add your message here'
      },
      resultMessageTwo: {
        label: 'Result Message for 26-50%',
        placeholder: 'Add your message here'
      },
      resultMessageThree: {
        label: 'Result Message for 51-75%',
        placeholder: 'Add your message here'
      },
      resultMessageFour: {
        label: 'Result Message for 76-100%',
        placeholder: 'Add your message here'
      }
    },
    reviewSectionTitle: 'Reviewed By',
    formEntrySix: {
      label: 'Medical Professional',
      optionPlaceholder: 'Select professional'
    },
    formEntrySeven: {
      label: 'Published By',
      placeholder: 'Enter publisher name'
    },
    questionList: {
      questionBullet: 'Q',
      actionBtns: {
        editBtnText: 'Edit',
        duplicateBtnText: 'Duplicate',
        deleteBtnText: 'Delete'
      }
    },
    formEntryEight: {
      label: 'Add Question here',
      placeholder: 'Enter your question'
    },
    formEntryNine: {
      label: 'Answer Choice',
      placeholder: 'Enter answer choices'
    },
    selectWeightText: 'Select Weight',
    choiceMenu: {
      secure: 'SECURE',
      avoidant: 'AVOIDANT',
      anxious: 'ANXIOUS',
      disorganized: 'DISORGANISED'
    },
    bulkAnswerBtnText: 'Bulk Answers',
    saveQuestionBtnText: 'Save Question',
    bulkAnswerModal: {
      modalTitle: 'Add Answers in Bulk',
      modalDescription: 'Enter each answer choice on a separate line',
      modalPlaceholder: 'Enter reason here...',
      characterLimitText: 'Character limit',
      cancelBtnText: 'Cancel',
      saveBtnText: 'Save'
    },
    shareAssessmentPageData: {
      shareAssessmentLabel: 'Share Assessment',
      addCoverImageLabel: 'Add cover image',
      optionalLabel: '(Optional)',
      dropeYourImageLabel: 'Drop your image here, or',
      browseLabel: 'browse',
      maximumFileSizeLabel: 'Maximum file size: 5MB',
      publishedTimeLabel: 'Publish Time',
      addDateLabel: 'Add Date',
      setDateLabel: 'Set Date',
      addTimeLabel: 'Add Time',
      setTimeLabel: 'Set Time',
      endPageLabel: 'End Page',
      headingTextLabel: 'Heading Text',
      headingTextPlaeholder: 'You have completed this Assessment.',
      bodyTextLabel: 'Body Text',
      bodyTextPlaceholder: 'Thank you for taking time to answer this Assessment.',
      sendAssessmentBtnText: 'Send Assessment',
      approvalModal: {
        descriptionOne: "You're currently unable to share this assessment with users",
        descriptionTwo: 'Send the assessment to an admin to get approval',
        placeholder: 'Select Admin...',
        sendForApprovalBtnText: 'Send for Approval'
      },
      successModal: {
        descriptionOne: 'Congratulation on successfully creating Self Assessment',
        descriptionTwo: 'You can now manage this assessment and access valuable insights',
        viewAllAssessmentBtnText: 'View All Assessments'
      },
      submitBtnText: 'Submit',
      saveAsDraftBtnText: 'Save as draft',
      viewAllAssessmentBtnText: 'View All Assessments',
      draftAssessmentSavedSuccessMessage: 'Draft assessment saved successfully.'
    }
  }
};
